<template>
  <b-modal class="modal-sm" size="sm" id="downloadModal" ref="downloadModal" :title="'Download'" :header-bg-variant="'secondary'" centered hide-header hide-backdrop hide-footer okVariant="secondary" @hide="hideOverlay()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'download']" size="1x" class="mr-2"/> Download Data</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="col-12 text-center">
          <a :href="$props.dataUrl" @click="hideModal()" class="btn btn-primary">{{ t('clickToDownloadText', 'clickToDownloadText') }}</a>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalDownloadData',
  props: ['dataUrl'],
  methods: {
    hideOverlay() {
      this.$parent.overlayActive = false
      this.$parent.alertShowing = false
    },

    hideModal() {
      this.$parent.overlayActive = false
      this.$parent.alertShowing = false
      this.$root.$emit('bv::hide::modal', 'downloadModal')
    }
  }
}
</script>

<style scoped>

</style>
